export const ICONS = {
  LEFT: 'chevronLeft',
  RIGHT: 'chevronRight'
};

export const WIDTHS = {
  ARROW: 28,
  ARROW_OFFSET: 32,
  SLIDE_MIN: 220,
  SLIDE_MAX: 380,
  PREVIEW_MOBILE_MAX: 300,
  CELL_PADDING: 8,
  IMG_WIDTH: 480,
  MOBILE_SLIDE_OFFSET: 80
};
